export default "__VITE_ASSET__b81c97ae__"